import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  DoCheck,
} from '@angular/core';
import { InputType } from '../../../../core/enums/inpuTypeEnum';
import { ProcessData } from '@usimweb/core/models';
import { SIMULATIONTYPE } from '../../../../core/enums/simulationTypeEnum';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
// import { WeatherDialogComponent } from '../../../../feature/dialogs/weather-dialog/weather-dialog.component';
// import { WeatherInformation } from '../../../../core/services/domain/simulation/simulation';
import { MassParameter } from '../../../../core/enums/massParameterEnum';
import { TimeParameter } from '../../../../core/enums/timeParameterEnum';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-process-data',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './process-data.component.html',
    styleUrls: ['./process-data.component.scss'],
    standalone: false
})
export class ProcessDataComponent implements OnInit, OnChanges {
  @Input() freeRiseDensity: number = 0;

  @Input() volume: number = 0;

  @Input() simulationType = SIMULATIONTYPE.RT;

  @Output() updateProcessData: EventEmitter<any> = new EventEmitter<any>();

  @Output() selectionChangeDensity: EventEmitter<any> = new EventEmitter<any>();

  @Output() injectionTimeChanged: EventEmitter<any> = new EventEmitter<any>();

  public simulationTypeEnum = SIMULATIONTYPE;

  public processData: ProcessData = { injectionRate: 0, targetDensity: 0 };
  public inputType = InputType;
  public injectionTime: number = 0;
  public overpackingFactor: number = 0;
  public mass: number = 0;

  public massParameter = MassParameter.OVERPACKING_FACTOR;
  public timeParameter = TimeParameter.INJECTION_RATE;
  public massParameters = [
    { value: 'Mass [kg]', key: MassParameter.MASS },
    { value: 'Target density [kg/m³]', key: MassParameter.TARGET_DENSITY },
    { value: 'Overpacking factor', key: MassParameter.OVERPACKING_FACTOR },
  ];
  public timeParameters = [
    { value: 'Injection rate [kg/s]', key: TimeParameter.INJECTION_RATE },
    { value: 'Injection time [s]', key: TimeParameter.INJECTION_TIME },
  ];

  public massParameterValue: number = 0;
  public timeParameterValue: number = 0;

  public defaultMassParameter!: number;
  public defaultTimeParameter!: number;

  public key = 'key';
  public value = 'value';

  public curveColumns: string[] = ['parameter', 'value'];
  public dataTableSource!: any[];

  public timeParameterMin = 0.001;
  public timeParameterMax = 50;

  public massParameterMin = 0.1;
  public massParameterMax = 10;

  constructor(private matDialog: MatDialog, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    // this.processData = { injectionRate: null, targetDensity: null };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.freeRiseDensity && changes['freeRiseDensity']) {
      this.freeRiseDensity = changes['freeRiseDensity'].currentValue;

      if (this.overpackingFactor || this.processData.targetDensity || this.mass) {
        this.assignParameters();
        this.massSelectionChanged(this.massParameterValue);
        this.timeParameterChanged(this.timeParameterValue);
      }
    }

    if (this.volume && changes['volume']) {
      this.volume = changes['volume'].currentValue;

      if (this.injectionTime || this.processData.injectionRate) {
        this.assignParameters();
        this.massSelectionChanged(this.massParameterValue);
        this.timeParameterChanged(this.timeParameterValue);
      }
    }
  }

  public setProcessData(processData: ProcessData) {
    this.massParameter = MassParameter.TARGET_DENSITY;
    this.defaultMassParameter = processData.targetDensity;
    this.massParameterChanged(processData.targetDensity);

    this.timeParameter = TimeParameter.INJECTION_RATE;
    this.defaultTimeParameter = processData.injectionRate;
    this.timeParameterChanged(processData.injectionRate);
  }

  // public openWeatherDialog() {
  //   const dialogConfig = new MatDialogConfig();
  //   dialogConfig.disableClose = false;
  //   dialogConfig.autoFocus = true;
  //   dialogConfig.width = String(screen.width * 0.6) + 'px';
  //   dialogConfig.data = {
  //   };
  //   const dialogRef = this.matDialog.open(WeatherDialogComponent, dialogConfig);
  //   dialogRef.afterClosed().subscribe(data => {
  //     if (data) {
  //         const wInfo = data as WeatherInformation;
  //         this.processData.ambientCondition = wInfo.locationName  + ' (' +
  //         wInfo.temperature + ' °C, ' + wInfo.humidity + ' %, ' +  wInfo.pressure + ' hPa)';
  //         this.foaming.ambientPressure = wInfo.pressure;
  //         this.foaming.ambientTemperature = wInfo.temperature;
  //         this.foaming.ambientMoisture = wInfo.humidity;

  //         this.getLocations();

  //         this.currentConditions =  wInfo.temperature  + ' °C, ' +
  //         wInfo.humidity  + ' %, ' +    wInfo.pressure + ' hPa ' +
  //         '(' +   wInfo.date  + ')';
  //         this.processData.ambientCondition = wInfo.locationName;
  //     }
  //   });
  // }

  public massParameterChanged(value: number) {
    this.massParameterValue = value;
    if (this.massParameter === MassParameter.MASS) {
      this.mass = value;
      this.processData.targetDensity = Math.round((this.mass / this.volume) * 1e3) / 1e3;
      this.overpackingFactor = Math.round((this.processData.targetDensity / this.freeRiseDensity) * 1e4) / 1e4;
      this.selectionChangeDensity.emit(this.processData.targetDensity);
      this.updateProcessData.emit(this.processData);

      this.massParameterMin = 0.01;
      this.massParameterMax = 100;
    }

    if (this.massParameter === MassParameter.TARGET_DENSITY) {
      this.processData.targetDensity = value;
      this.mass = Math.round(this.volume * this.processData.targetDensity * 1e3) / 1e3;
      this.overpackingFactor = Math.round((this.processData.targetDensity / this.freeRiseDensity) * 1e4) / 1e4;
      this.selectionChangeDensity.emit(this.processData.targetDensity);
      this.updateProcessData.emit(this.processData);

      this.massParameterMin = 1;
      this.massParameterMax = 1000;
    }

    if (this.massParameter === MassParameter.OVERPACKING_FACTOR) {
      this.overpackingFactor = value;
      this.processData.targetDensity = Math.round(this.freeRiseDensity * this.overpackingFactor * 1e3) / 1e3;
      this.mass = Math.round(this.volume * this.processData.targetDensity * 1e3) / 1e3;
      this.selectionChangeDensity.emit(this.processData.targetDensity);
      this.updateProcessData.emit(this.processData);

      this.massParameterMin = 0.1;
      this.massParameterMax = 10;
    }

    this.assignParameters();
    this.cd.detectChanges();
  }

  public timeParameterChanged(value: number) {
    this.timeParameterValue = value;
    if (this.timeParameter === TimeParameter.INJECTION_RATE) {
      this.processData.injectionRate = value;
      this.injectionTime = Math.round((this.mass / this.processData.injectionRate) * 1e4) / 1e4;
      this.injectionTimeChanged.emit(this.injectionTime);
      this.updateProcessData.emit(this.processData);

      this.timeParameterMin = 0.001;
      this.timeParameterMax = 50;
    }

    if (this.timeParameter === TimeParameter.INJECTION_TIME) {
      this.injectionTime = value;
      this.processData.injectionRate = Math.round((this.mass / this.injectionTime) * 1e4) / 1e4;
      this.injectionTimeChanged.emit(this.injectionTime);
      this.updateProcessData.emit(this.processData);

      this.timeParameterMin = 0.1;
      this.timeParameterMax = 30;
    }

    this.assignParameters();
    this.cd.detectChanges();
  }

  public massSelectionChanged(value: number) {
    if (value) {
      this.massParameterChanged(value);
    }
  }

  public timeSelectionChanged(value: number) {
    if (value) {
      this.timeParameterChanged(value);
    }
  }

  private assignParameters() {
    const parameter = [];

    parameter.push({
      parameter: 'Free rise density [kg/m³]',
      value: Math.round(this.freeRiseDensity * 1e4) / 1e4,
    });
    parameter.push({
      parameter: 'Target Density [kg/m³]',
      value: this.processData.targetDensity,
    });
    parameter.push({ parameter: 'Mass [kg]', value: this.mass });
    parameter.push({
      parameter: 'Overpacking factor',
      value: this.overpackingFactor,
    });
    parameter.push({
      parameter: 'Injection rate [kg/s]',
      value: this.processData.injectionRate,
    });
    parameter.push({
      parameter: 'Injection time [s]',
      value: this.injectionTime,
    });

    this.dataTableSource = parameter;
  }
}
